import { useEffect, useState, useCallback } from "react";
import { PendingActivity } from "./PendingActivities";
import EmptyState from "./EmptyState";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { searchInvitedBusiness } from "services/SauceService";
import InvitationsTable from "../invitations-table";
import "./PendingActivities.scss";

interface InvitationsTabProps {
  loading?: boolean;
  showCreatorInfo?: boolean;
  onCancel?: (invite: PendingActivity) => void;
  isActive?: boolean;
  onRefresh?: () => void;
  creatorId?: string;
}

const InvitationsTab: React.FC<InvitationsTabProps> = ({
  loading: externalLoading,
  showCreatorInfo,
  onCancel,
  isActive = false,
  onRefresh,
  creatorId,
}) => {
  const [invitations, setInvitations] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchInvitations = useCallback(async () => {
    setLoading(true);
    try {
      const businessId = localStorage.getItem("businessId");
      if (!businessId) {
        setInvitations([]);
        return;
      }

      const response: any = await searchInvitedBusiness({
        businessId,
        creatorId: creatorId,
      });

      setInvitations(response);
    } catch (err) {
      console.error("Failed to fetch invitations", err);
      setInvitations([]);
    } finally {
      setLoading(false);
    }
  }, [creatorId]);

  useEffect(() => {
    if (isActive) {
      fetchInvitations();
    }
  }, [isActive, fetchInvitations]);

  const handleCancel = useCallback(
    async (invite: PendingActivity) => {
      await onCancel?.(invite);
      if (isActive) {
        await fetchInvitations();
      }
      onRefresh?.();
    },
    [onCancel, isActive, fetchInvitations, onRefresh]
  );

  if (invitations.length === 0 && !loading && !externalLoading) {
    return (
      <EmptyState
        icon={faEnvelope}
        title="No Invitations Sent"
        description="You haven't sent any invitations yet. Invite creators to your campaigns to get started."
      />
    );
  }

  return (
    <InvitationsTable
      dataSource={invitations}
      loading={loading || externalLoading}
      showCreatorInfo={showCreatorInfo}
      onCancel={handleCancel}
    />
  );
};

export default InvitationsTab;
